<template>
    <div v-if="overlay">
        
        <v-overlay v-if="overlay && loading" :value="loading" :absolute="absolute" :opacity="0.35">
            <v-progress-circular indeterminate :size="size">

                <div v-if="text" class="text-center">
                    {{text}}
                </div>

            </v-progress-circular>                                       
        </v-overlay>
        <slot />


    </div>
    <div v-else>

        <div v-if="loading" :class="[ loading ? 'd-flex' : 'd-none', 'justify-center']">
            <v-progress-circular indeterminate :size="size" />
        </div>
        
        <div v-if="lazy">
            <div v-if="!loading">
             <slot />
             </div>
        </div>

        <div v-else  v-show="!loading" :class="{'d-none': loading }">
            <slot />
        </div>

       

    </div>
</template>

<script>
    export default {
        props: {
            loading: {
                type: Boolean,
                default: false,
                required: false
            },
            overlay: {
                type: Boolean,
                default: false,
                required: false
            },
            lazy: {
                type: Boolean,
                default: false,
                required: false
            },
            absolute: {
                type: Boolean,
                default: false,
                required: false
            },
            size: {
                type: Number,
                default: 120,
                required: false
            },
            text: {
                type: String,
                require: false
            }
        }
    }
</script>

<style>

</style>